var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicLogoPaymentTrustly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 26,
    fill: "none",
    viewBox: "0 0 40 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0EE06E",
    d: "M0 0h40v26H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.18 20.52v-4.66H7.5v-1.02h4.47v1.02h-1.68v4.66h-1.1Zm2.66 0V16.4h1.03v.65c.27-.55.6-.65.96-.65h.4v1.03h-.35c-.52 0-.98.3-.98 1.21v1.88h-1.06Zm2.97-1.49V16.4h1.06v2.38c0 .53.27.88.75.88.47 0 .82-.35.82-.87v-2.4h1.06v4.13h-1.02V20c-.27.42-.68.61-1.2.61-.86 0-1.47-.57-1.47-1.58Zm4.25.32.93-.2c.04.36.34.6.83.6.4 0 .64-.17.64-.39 0-.18-.11-.3-.5-.4l-.67-.15c-.79-.18-1.15-.55-1.15-1.24 0-.7.58-1.25 1.65-1.25 1.13 0 1.6.67 1.66 1.15l-.94.2c-.04-.25-.23-.52-.75-.52-.33 0-.58.15-.58.37 0 .2.15.3.37.36l.91.21c.71.17 1.05.59 1.05 1.2 0 .66-.54 1.31-1.68 1.31-1.25 0-1.72-.74-1.77-1.25Zm5.64 1.17c-.72 0-1.16-.4-1.16-1.15v-2.05h-.7v-.92h.7v-.95l1.05-.3v1.25h.84v.92h-.84v1.86c0 .3.15.42.46.42h.46v.92h-.82Zm1.5 0v-5.68h1.05v5.68h-1.06Zm4.55-4.12h1.13L30.14 22H29l.49-1.48h-.58l-1.17-4.12h1.13l.9 3.24.98-3.24ZM13.87 7.82h4.07V4.57l3.24 3.25-3.24 3.25v1.66h3.94v-4.9h3.62V4H13.87v3.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogoPaymentTrustly);
export default __webpack_public_path__ + "static/media/graphic-logo-payment-trustly.8aeec63f.svg";
export { ForwardRef as ReactComponent };